import { Component, OnDestroy, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { ApiTesterService } from '@core/services/api-tester.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'rh-api-tester',
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    ReactiveFormsModule,
  ],
  templateUrl: './api-tester.component.html',
})
export class ApiTesterComponent implements OnDestroy {
  readonly apiTesterService = inject(ApiTesterService);
  readonly httpBody = new FormControl(this.apiTesterService.httpBody());

  get responseLabel$() {
    return this.apiTesterService.responseLabel();
  }

  get requestInProgress$() {
    return this.apiTesterService.requestInProgress();
  }

  get responseBody$() {
    return this.apiTesterService.responseBody();
  }

  ngOnDestroy(): void {
    this.apiTesterService.clearResponse();
  }

  public convertBodyValue(value: string) {
    return JSON.stringify(value, null, 2);
  }
}
